import $ from 'jquery';
import Slider from './Slider';
import settings from './Settings.Difference';

function DifferenceSlider(element) {
  this.element = element;
  this.$element = $(element);
  this.slider = this.addSlider();
  this.removeLink = this.removeLinks();
}

DifferenceSlider.prototype = {
  addSlider() {
    return new Slider(this.element, settings);
  },
  removeLinks() {
    return this.$element.find('.node-header a').each((i, element) => {
      $(element).children().unwrap();
    });
  },
};

export default DifferenceSlider;



// WEBPACK FOOTER //
// ./DifferenceSlider.js